// src/pages/CustomerUnitsPage.js
// Customer-owned units — units in for service, awaiting customer pickup, or
// otherwise customer-owned and not part of SNA's stock fleet.
import React, { useEffect, useMemo, useState } from 'react';
import { api } from '../scripts/api';
import CardComponent from '../components/CardComponent';
import { parseBool } from '../scripts/status';

const matchesSearch = (row, q) =>
  !q || JSON.stringify(row).toLowerCase().includes(q.trim().toLowerCase());

export default function CustomerUnitsPage() {
  const [rows, setRows]     = useState([]);
  const [q, setQ]           = useState('');
  const [loading, setLoading] = useState(false);
  const [errMsg, setErrMsg]   = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setLoading(true);
        setErrMsg('');
        const res = await api.get('/all_inventory');
        if (!alive) return;
        setRows(Array.isArray(res.data) ? res.data : []);
      } catch (e) {
        if (!alive) return;
        console.error(e);
        setRows([]);
        setErrMsg('Failed to load inventory.');
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  const filtered = useMemo(() => {
    return rows
      .filter(r => parseBool(r.is_customer_unit))
      .filter(r => matchesSearch(r, q));
  }, [rows, q]);

  return (
    <div className="container">
      <h2>Customer Units <span className="muted" style={{ fontSize: 13, fontWeight: 400 }}>(customer-owned)</span></h2>

      <input className="input" placeholder="Search…" value={q} onChange={(e) => setQ(e.target.value)} />

      {loading && <div className="muted">Loading…</div>}
      {!loading && errMsg && <div className="muted">{errMsg}</div>}
      {!loading && !errMsg && filtered.length === 0 && (
        <div className="muted">
          No customer units. Mark a record's <strong>Customer Unit</strong> checkbox under Status &amp; Classification to add one.
        </div>
      )}

      <div className="col">
        {filtered.map((r) => (
          <CardComponent key={r.id} record={r} table="all_inventory" />
        ))}
      </div>
    </div>
  );
}
